/*
 * Header — top bar with title, query echo, status dot, "new search" button.
 * Ported from ui-handoff/.../app.jsx::Header. Pure presentational; phase comes
 * from the App state machine.
 */

import React from 'react';

const STATUS_LABELS = {
  idle: 'agent · idle',
  loading: 'agent · streaming',
  results: 'agent · ready',
  empty: 'agent · no match',
  error: 'agent · error',
};

export function Header({ phase, query, elapsed, onNewSearch, onOpenHistory }) {
  return (
    <header className="hdr">
      <div className="hdr-l">
        <div className="hdr-mark">
          <svg viewBox="0 0 24 24" width="22" height="22" aria-hidden>
            <rect x="2" y="5" width="20" height="14" rx="0.5" fill="none" stroke="currentColor" strokeWidth="1.5" />
            <path d="M10 9 L16 12 L10 15 Z" fill="currentColor" />
          </svg>
        </div>
        <div className="hdr-wm">
          <div className="hdr-title serif">Video Search Agent</div>
          <div className="hdr-sub mono">v0.2 · curator</div>
        </div>
      </div>

      {phase !== 'idle' && (
        <div className="hdr-c">
          <div className="hdr-q-label mono">query</div>
          <div className="hdr-q serif">"{query}"</div>
        </div>
      )}

      <div className="hdr-r">
        <button type="button" className="hdr-btn mono" onClick={onOpenHistory}>
          <svg viewBox="0 0 24 24" width="12" height="12">
            <path d="M4 4 H20 V20 H4 Z M4 9 H20 M9 4 V20" fill="none" stroke="currentColor" strokeWidth="1.5" />
          </svg>
          past queries
        </button>
        {phase !== 'idle' && (
          <button type="button" className="hdr-btn mono" onClick={onNewSearch}>
            <svg viewBox="0 0 24 24" width="12" height="12">
              <path d="M5 12 H19 M5 12 L11 6 M5 12 L11 18" fill="none" stroke="currentColor" strokeWidth="1.5" />
            </svg>
            new search
          </button>
        )}
        <div className="hdr-status mono">
          <span className={`hdr-status-dot hdr-status-${phase}`} />
          <span>{STATUS_LABELS[phase]}</span>
          {phase === 'loading' && (
            <span className="num" style={{ marginLeft: 8, color: 'var(--ink-3)' }}>
              {elapsed.toFixed(1)}s
            </span>
          )}
        </div>
      </div>

      <style>{`
        .hdr {
          display: grid; grid-template-columns: minmax(0,1fr) minmax(0, 1.6fr) minmax(0,1fr);
          align-items: center; gap: 32px;
          padding: 22px 36px;
          border-bottom: 1px solid var(--rule);
          background: var(--bg);
          position: sticky; top: 0; z-index: 30;
        }
        .hdr-l { display: flex; align-items: center; gap: 14px; }
        .hdr-mark { color: var(--accent); }
        .hdr-wm { display: flex; flex-direction: column; line-height: 1.1; }
        .hdr-title { font-size: 19px; font-weight: 400; letter-spacing: -0.005em; color: var(--ink); }
        .hdr-sub { font-size: 10px; letter-spacing: 0.16em; text-transform: uppercase; color: var(--ink-3); margin-top: 2px; }
        .hdr-c { display: flex; flex-direction: column; align-items: center; gap: 4px; min-width: 0; max-width: 100%; }
        .hdr-q-label { font-size: 9.5px; letter-spacing: 0.18em; text-transform: uppercase; color: var(--ink-3); }
        .hdr-q { font-size: 18px; color: var(--ink); white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 100%; font-style: italic; font-weight: 300; }
        .hdr-r { display: flex; align-items: center; justify-content: flex-end; gap: 14px; }
        .hdr-btn {
          background: transparent; border: 1px solid var(--rule-2); color: var(--ink-2);
          padding: 6px 10px; font-size: 11px; letter-spacing: 0.04em;
          display: inline-flex; align-items: center; gap: 6px;
        }
        .hdr-btn:hover { color: var(--ink); border-color: var(--ink); }
        .hdr-status { display: flex; align-items: center; gap: 8px; font-size: 10.5px; letter-spacing: 0.06em; color: var(--ink-2); }
        .hdr-status-dot { width: 7px; height: 7px; border-radius: 99px; background: var(--ink-3); }
        .hdr-status-idle { background: var(--ink-3); }
        .hdr-status-loading { background: var(--accent); box-shadow: 0 0 8px var(--accent); animation: dot-pulse 1.4s ease-in-out infinite; }
        .hdr-status-results { background: var(--pos); }
        .hdr-status-empty { background: var(--warn); }
        .hdr-status-error { background: #c93a2a; box-shadow: 0 0 8px #c93a2a; }
        @keyframes dot-pulse { 50% { opacity: 0.4; } }
      `}</style>
    </header>
  );
}
